export default __webpack_public_path__ + "3VSnEhY-notification.svg";